import type { ApolloError } from '@apollo/client';
import { useTypedQuery } from '../lib/generated/zeus/apollo';
import { genericScalars } from '../lib/graphql/helpers';
import { qualificationSelector } from './selectors/qualification';

/**
 * Query qualifications with provided conditions, either with qualification name or qualification code
 * @param limit number of results to be returned for the query.
 * @param offset result set start offset.
 * @param query the query string to filter qualifications by (partial names or codes)
 * @returns qualification query result.
 */
const useQueryQualification = (
  limit: number,
  offset: number,
  query: string,
  onError: (e: ApolloError) => void
) => {
  // Generate an SQL LIKE string based on the query to be used in the
  // qualification filtering below
  const qualificationLikeString = `%${query}%`;
  // We want to partially match on _either_ the qualification name OR code (abbrev)
  const qualificationQueryCondition = {
    _or: [
      {
        name: {
          _ilike: qualificationLikeString,
        },
      },
      {
        abbrev: {
          _ilike: qualificationLikeString,
        },
      },
    ],
  };

  return useTypedQuery(
    {
      qualification: [
        {
          where: { ...qualificationQueryCondition },
          limit,
          offset,
        },
        qualificationSelector,
      ],
    },
    {
      scalars: genericScalars,
      apolloOptions: { onError },
    }
  );
};

export default useQueryQualification;
